import {useEffect, useRef, useState} from "react";

const useCheckbox = (data, idName) => {
  const [checked, setChecked] = useState([]);
  const checkboxesParent = useRef(null);
  const parentCheckbox = useRef(null);

  const handleCheck = (e) => {
    const {name} = e.target;
    if (e.target.checked) {
      setChecked([...checked, name]);
    } else {
      setChecked(checked.filter((item) => item !== name));
    }
  }

  useEffect(() => {
    if (parentCheckbox.current.checked) {
      parentCheckbox.current.checked = false;
    }
  }, [data]);

  const  handleCheckAll = (e) => {
    const inputs = checkboxesParent.current.querySelectorAll('input');
    if (e.target.checked) {
      inputs.forEach((input) => (input.checked = true));
      setChecked(data.map((item) => item[idName]));
    } else {
      inputs.forEach((input) => (input.checked = false));
      setChecked([]);
    }
  }



  return {
    checked,
    checkboxesParent,
    handleCheck,
    handleCheckAll,
    parentCheckbox
  }
}

export default useCheckbox
